import "./Access.module.css";
import Header from "@/reusable_sections/Header";
import SecureAuthHub from "./sections/SecureAuthHub";
import SecurityStandards from "./sections/SecurityStandards";
import HelpFaq from "./sections/HelpFaq";
import Footer from "@/reusable_sections/Footer";
export default function AccessPage() {
  return <div>
      <Header />
      <SecureAuthHub />
      <SecurityStandards />
      <HelpFaq />
      <Footer />
    </div>;
}